import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { cyclicTabbingService } from './cyclicTabbingService'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(cyclicTabbingService)
}

export const editor = site
